import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var SocialTwitter = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 100 100"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5 26.12a31.562 31.562 0 01-9.073 2.486 15.841 15.841 0 006.945-8.738A31.583 31.583 0 0176.341 23.7a15.783 15.783 0 00-11.531-4.988c-8.724 0-15.798 7.072-15.798 15.798 0 1.237.14 2.444.41 3.601-13.13-.659-24.77-6.949-32.562-16.508a15.73 15.73 0 00-2.139 7.943 15.791 15.791 0 007.028 13.149 15.762 15.762 0 01-7.155-1.976c-.002.066-.002.131-.002.199 0 7.652 5.445 14.037 12.671 15.49a15.892 15.892 0 01-7.134.27c2.01 6.275 7.844 10.844 14.757 10.972a31.704 31.704 0 01-19.62 6.763c-1.275 0-2.532-.074-3.769-.221a44.715 44.715 0 0024.216 7.096c29.058 0 44.948-24.071 44.948-44.945 0-.684-.016-1.367-.046-2.046A32.03 32.03 0 0088.5 26.12z"
  }));
});
SocialTwitter.displayName = 'SocialTwitter';
export var SocialTwitterDimensions = {
  height: 100,
  width: 100
};